import { Button, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { Exercises } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStateValue } from "../../config/AppContext";
import { ExerciseEquipment, ExerciseFocus, ExerciseTypesEnum } from "../../types/StaticTypes";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridGap: 5,
  },
  previewPhoto: {
    height: "120px",
    // backgroundSize: 'contain',
    backgroundRepeat: "no-repeat",
    color: "#495057",
    display: "flex",
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    fontSize: 14,
    backgroundSize: "100% 120px",
  },
  addPhotoContainer: {
    flexBasis: "100%",
    height: 0,
    textAlign: "center",
    zIndex: -1,
  },
  textForPhotoSelect: {
    zIndex: -1,
  },
  saveBtn: {
    width: "100%",
    backgroundColor: "var(--primary)",
    color: "white",
  },
}));

const ExercisesAddComponent: React.FC = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { catalog, Methods } = useStateValue();
  const [exerciseType, setExerciseType] = React.useState<string>();

  if (!catalog || !Methods) return <></>;

  const generateTypesList = () => {
    let Types: React.ReactElement[] = [];
    for (let i = 0; i < 6; i++) {
      Types = [
        ...Types,
        <option key={i} style={{ textTransform: "capitalize" }} value={ExerciseTypesEnum[i]}>
          {catalog.typesDisplay(ExerciseTypesEnum[i]).toLowerCase()}
        </option>,
      ];
    }
    return Types;
  };
  const generateFocusList = () => {
    let Focus: React.ReactElement[] = [];
    for (let i = 0; i < 10; i++) {
      Focus = [
        ...Focus,
        <option key={i} style={{ textTransform: "capitalize" }} value={ExerciseFocus[i]}>
          {ExerciseFocus[i].toLowerCase()}
        </option>,
      ];
    }
    return Focus;
  };
  const generateEquipmentList = () => {
    let Equipment: React.ReactElement[] = [];
    for (let i = 0; i < 39; i++) {
      Equipment = [
        ...Equipment,
        <option key={i} style={{ textTransform: "capitalize" }} value={ExerciseEquipment[i]}>
          {catalog.equipmentsDisplay(ExerciseEquipment[i]).toLowerCase()}
        </option>,
      ];
    }
    return Equipment;
  };
  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    let params: Exercises.IExercise | {} = {};
    const formData = new FormData(e.currentTarget);
    formData.forEach((v, k) => (params = { ...params, [k]: v }));
    await Methods.addExercises(params);
    await Methods.getExercises();

    // console.log("props",props)

    return props.history ? props.history.goBack() : "";
  };
  const handleImageUpload = async (e: any) => {
    const newImage: File = e.currentTarget.files && e.currentTarget.files[0];
    const inputId = e.currentTarget.id;
    if (inputId) {
      let preview: HTMLElement | any;
      let photo_id: HTMLInputElement | any;
      switch (inputId) {
        case "file1":
          preview = document.getElementById("preview_photo_start");
          photo_id = document.getElementById("photo_start");
          break;
        case "file2":
          preview = document.getElementById("preview_photo_end");
          photo_id = document.getElementById("photo_end");
          break;
        default:
          break;
      }
      const image = await Methods.updateImage(newImage);
      if (preview && photo_id) {
        preview.style.backgroundImage = `url(${image.small})`;
        photo_id.value = image.id;
      }
    }
  };

  const triggerImageUpload = (e: React.MouseEvent) => {
    // const target = e.currentTarget.id;
    const target = e.currentTarget.children.item(0)?.children?.item(0)?.id;

    const file1 = document.getElementById("file1");
    const file2 = document.getElementById("file2");
    // console.log('file1', file1, file2)
    switch (target) {
      case "photo_start":
        if (file1) return file1.click();
        break;
      case "photo_end":
        if (file2) return file2.click();
        break;
      default:
        break;
    }
  };

  /**
   * Validate YouTube url
   */
  const validateUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regExp = new RegExp("^(https?://)?((www.)?youtube.com|youtu.?be)/*");
    if (regExp.test(e.currentTarget.value)) {
      e.currentTarget.toggleAttribute("invalid", false);
      e.currentTarget.classList.toggle("invalid", false);
      return;
    }
    e.currentTarget.toggleAttribute("invalid", true);
    e.currentTarget.classList.toggle("invalid", true);
  };
  return (
    <div id="exercise-add">
      <TextField id="file1" type="file" style={{ display: "none" }} onChange={handleImageUpload} />
      <TextField id="file2" type="file" style={{ display: "none" }} onChange={handleImageUpload} />
      <form onSubmit={handleSubmit}>
        <section>
          <label htmlFor="name" className="section-heading">
            {t("EXERCISE NAME")}
          </label>
          <input
            id="name"
            name="name"
            type="text"
            className="form-control add-excercise"
            // onChange={validateInput}
            // onBlur={validateInput}
            required
            title=""
            // autoFocus={true}
            onInvalid={(e) => {
              e.currentTarget.setCustomValidity(`${t("Exercise Name cannot be empty.")}`);
            }}
            onInput={(e) => {
              e.currentTarget.setCustomValidity(``);
            }}
          />
          <span className="form-errors"></span>
        </section>
        <section>
          <label htmlFor="type" className="section-heading">
            {t("EXERCISE TYPE")}
          </label>
          <select
            className="form-control add-excercise"
            id="type"
            name="type"
            style={{ textTransform: "capitalize" }}
            value={exerciseType}
            onChange={(e) => setExerciseType(e.currentTarget.value)}
            required
            title=""
            onInvalid={(e) => {
              e.currentTarget.setCustomValidity(`${t("Please select an exercise type")}`);
            }}
            onInput={(e) => {
              e.currentTarget.setCustomValidity(``);
            }}
          >
            <option value=""></option>
            {generateTypesList()}
          </select>
          <span className="form-errors"></span>
        </section>
        {/* {exerciseType && exerciseType === ExerciseTypes[4] && (
          <section>
            <label htmlFor='subtype' className='section-heading'>
              {t("Subcategory")}
            </label>
            <select
              id='subtype'
              className='form-control add-excercise'
              name='subtype'
              style={{ textTransform: 'capitalize' }}
            >
              <option value=''></option>
              {generateCategoryList()}
            </select>
            <span className='form-errors'></span>
          </section>
        )} */}
        <section>
          <label htmlFor="focus_prim" className="section-heading">
            {t("PRIMARY FOCUS")}
          </label>
          <select
            id="focus_prim"
            className="form-control add-excercise"
            name="focus_prim"
            style={{ textTransform: "capitalize" }}
            required
            title=""
            onInvalid={(e) => {
              e.currentTarget.setCustomValidity(`${t("Please select a primary focus")}`);
            }}
            onInput={(e) => {
              e.currentTarget.setCustomValidity(``);
            }}
          >
            <option value=""></option>
            {generateFocusList()}
          </select>
          <span className="form-errors"></span>
        </section>
        <section>
          <label htmlFor="focus_sec" className="section-heading">
            {t("SECONDARY FOCUS")}
          </label>
          <select
            id="focus_sec"
            className="form-control add-excercise"
            name="focus_sec"
            style={{ textTransform: "capitalize" }}
          >
            <option value=""></option>
            {generateFocusList()}
          </select>
          <span className="form-errors"></span>
        </section>
        <section>
          <label htmlFor="equipment" className="section-heading">
            {t("Equipment")}
          </label>
          <select
            id="equipment"
            className="form-control add-excercise"
            name="equipment"
            style={{ textTransform: "capitalize" }}
            required
            title=""
            onInvalid={(e) => {
              e.currentTarget.setCustomValidity(`${t("Please select an equipment")}`);
            }}
            onInput={(e) => {
              e.currentTarget.setCustomValidity(``);
            }}
          >
            <option value=""></option>
            {generateEquipmentList()}
          </select>
          <span className="form-errors"></span>
        </section>
        <section>
          <label htmlFor="EXERCISE NOTES" className="section-heading">
            {t("EXERCISE NOTES")}
          </label>
          <textarea
            id="notes"
            name="notes"
            rows={3}
            className="form-control add-excercise"
            style={{ resize: "none" }}
          />
          <span className="form-errors"></span>
        </section>
        <section>
          <label htmlFor="description" className="section-heading">
            {t("DESCRIPTION")}
          </label>
          <textarea
            id="description"
            className="form-control add-excercise"
            name="description"
            rows={5}
            style={{ resize: "none" }}
            required
            title=""
            onInvalid={(e) => {
              e.currentTarget.setCustomValidity(`${t("This field is required")}`);
            }}
            onInput={(e) => {
              e.currentTarget.setCustomValidity(``);
            }}
          />
          <span className="form-errors"></span>
        </section>
        <section style={{ marginTop: "15px" }}>
          <label className="section-heading">{t("PHOTO")}</label>
          <div className={classes.imageContainer}>
            <label htmlFor="photo_start" style={{ border: "#9b9b9b 1px solid" }}>
              <TextField
                type="text"
                id="photo_start"
                name="photo_start_id"
                style={{ display: "none" }}
                onClick={triggerImageUpload}
              />
              <span id="preview_photo_start" className={classes.previewPhoto}>
                <div className={classes.addPhotoContainer}>
                  <CameraAltIcon style={{ color: "rgb(62, 127, 233)" }} />
                </div>
                <p className={classes.textForPhotoSelect}>{t("Add photo for start position")}</p>
              </span>
            </label>
            <label htmlFor="photo_end" style={{ border: "#9b9b9b 1px solid" }}>
              <TextField
                type="text"
                id="photo_end"
                name="photo_end_id"
                style={{ display: "none" }}
                onClick={triggerImageUpload}
              />
              <span id="preview_photo_end" className={classes.previewPhoto}>
                <div className={classes.addPhotoContainer}>
                  <CameraAltIcon style={{ color: "rgb(62, 127, 233)" }} />
                </div>
                <p className={classes.textForPhotoSelect}>{t("Add photo for end position")}</p>
              </span>
            </label>
          </div>
          <label htmlFor="video" className="section-heading">
            {t("VIDEO")}
          </label>
          <TextField
            id="video"
            type="url"
            name="video"
            className="form-control add-excercise"
            // title='Enter a valid Youtube URL'
            onChange={validateUrl}
            onInvalid={() => {
              const x = document.getElementById("video") as HTMLInputElement;
              x?.setCustomValidity(`${t("Invalid URL")}`);
            }}
            onInput={() => {
              const x = document.getElementById("video") as HTMLInputElement;
              x?.setCustomValidity(``);
            }}
          />
          <span className="form-errors" style={{ display: "block", minHeight: "25px" }}></span>
        </section>
        <section style={{ margin: "15px 0" }}>
          <Button type="submit" variant="contained" className={classes.saveBtn}>
            {t("Save")}
          </Button>
        </section>
      </form>
    </div>
  );
};
export default ExercisesAddComponent;
